import { render, staticRenderFns } from "./TransactionsMenu.vue?vue&type=template&id=3a59d6d4&scoped=true&"
import script from "./TransactionsMenu.vue?vue&type=script&lang=js&"
export * from "./TransactionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsMenu.vue?vue&type=style&index=0&id=3a59d6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a59d6d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
